<template>
  <div class="radial-bar">
    <svg
      class="radial-bar__inner"
      height="48"
      width="48"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="radial-bar__bar"
        cx="24"
        cy="24"
        r="22"
        fill="transparent"
        stroke="#edf4fa"
        stroke-width="3"
      />
      <circle
        class="radial-bar__bar"
        cx="24"
        cy="24"
        r="22"
        fill="transparent"
        stroke="#1A82CB"
        stroke-width="3"
        :stroke-dasharray="val"
      />
      <text
        x="50%"
        y="53%"
        dominant-baseline="middle"
        text-anchor="middle"
        class="radial-bar__value"
      >
        {{ value }}%
      </text>
    </svg>

    <div class="radial-bar__title">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name:"radial-bar",

  props: {
    value: {
      type: Number,
      default: 0,
      validator: function (value) {
        return value >= 0 && value <= 100;
      },
    },
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    val() {
      const circle = Math.PI * (22 * 2);
      const value = (circle / 100) * this.value;

      return `${value},${circle}`;
    }
  }
}
</script>

<style lang="scss">
  .radial-bar {
    font-size: 0;
    display: inline-block;
    text-align: center;

    &__bar {
      transform: rotate(-90deg);
      transform-origin: center;
    }

    &__value {
      font-size: 16px;
      font-weight: bold;
    }

    &__inner {
      margin-bottom: 9px;

      @include breakpoint("tablet") {
        width: 36px;
        height: 36px;
        margin-bottom: 4px;
      }

      @include breakpoint("desktop") {
        width: 48px;
        height: 48px;
      }
    }

    &__title {
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      font-weight: bold;

      @include breakpoint("tablet") {
        font-size: 8px;
      }

      @include breakpoint("desktop") {
        font-size: 12px;
      }
    }
  }
</style>